import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container-row align-center gap10" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "flex-container-row align-center gap10"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_equipment_serial_number_cell = _resolveComponent("equipment-serial-number-cell")!
  const _component_loader = _resolveComponent("loader")!
  const _component_my_grid = _resolveComponent("my-grid")!
  const _component_lazy = _resolveComponent("lazy")!

  return (_openBlock(), _createBlock(_component_lazy, null, {
    default: _withCtx(() => [
      _createVNode(_component_my_grid, {
        data: _ctx.equipmentRows,
        columns: _ctx.columns,
        "initial-sort": _ctx.initialSort,
        filterable: true,
        state: () => _ctx.gridState,
        pageable: true,
        pageSize: 50
      }, {
        customTemplate1: _withCtx(({props}) => [
          _createVNode(_component_equipment_serial_number_cell, {
            id: _ctx.getId(props.dataItem.equipmentNumber),
            "data-item": props.dataItem,
            onClick: ($event: any) => (_ctx.redirectToDevice(props.dataItem))
          }, null, 8, ["id", "data-item", "onClick"])
        ]),
        customTemplate2: _withCtx(({props}) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.statusIcon(props.dataItem)
            }, null, 8, _hoisted_2),
            _createElementVNode("div", {
              style: _normalizeStyle(_ctx.statusColor(props.dataItem))
            }, _toDisplayString(props.dataItem.status), 5)
          ])
        ]),
        customTemplate3: _withCtx(({props}) => [
          (props.dataItem.bomWarningCount == null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_loader, { size: "20px" })
              ]))
            : (props.dataItem.bomWarningCount > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", { src: _ctx.iconWarningPath }, null, 8, _hoisted_5),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.showWarnings(props.dataItem.equipmentNo)), ["prevent"]),
                    class: "blue-textlink"
                  }, _toDisplayString(props.dataItem.bomWarningCount), 9, _hoisted_6)
                ]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data", "columns", "initial-sort", "state"])
    ]),
    _: 1
  }))
}